.container {
  min-height: calc(100vh - var(--navbar-height));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-xl);
  text-align: center;
}

.ascii {
  font-family: var(--font-code);
  font-size: clamp(0.3rem, 0.9vw, 0.55rem);
  color: var(--accent-magenta);
  text-shadow: 0 0 10px var(--glow-magenta);
  margin-bottom: var(--space-xl);
  line-height: 1.2;
}

.info {
  margin-bottom: var(--space-xl);
}

.code {
  font-family: var(--font-heading);
  font-size: var(--text-2xl);
  color: var(--accent-magenta);
  margin-bottom: var(--space-sm);
  letter-spacing: 4px;
}

.message {
  font-family: var(--font-heading);
  font-size: var(--text-sm);
  color: var(--text-secondary);
  letter-spacing: 2px;
  margin-bottom: var(--space-md);
}

.hint {
  font-size: var(--text-sm);
  color: var(--text-muted);
}

.link {
  font-family: var(--font-heading);
  font-size: var(--text-sm);
  color: var(--accent-cyan);
  text-decoration: none;
  padding: var(--space-sm) var(--space-lg);
  border: 1px solid var(--border-accent);
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
  letter-spacing: 2px;
}

.link:hover {
  background: var(--glow-cyan);
  box-shadow: 0 0 15px var(--glow-cyan);
}
